import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0db9666a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-sm navbar-dark bg-white shadow-sm" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-3 fw-bold icon bi-list" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "header_container" }
const _hoisted_6 = { class: "navbar-nav mb-2 mb-lg-0 d-flex w-100 justify-content-end flex-row" }
const _hoisted_7 = { class: "nav-item dropdown notify-li d-none" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-icon icon bi-bell-fill" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-name" }, "Notification", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "dropdown-menu",
  "aria-labelledby": "notify-li"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "p-4" })
], -1))
const _hoisted_11 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = {
  class: "btn btn-transparent border-0 dropdown-toggle px-0",
  href: "#",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "aria-label": "Toggle dropdown"
}
const _hoisted_14 = { class: "px-3 text-primary drop-text d-md-inline-block" }
const _hoisted_15 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-user-edit" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item text-primary click",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-unlock" }),
  /*#__PURE__*/_createTextVNode(" Log out")
], -1))
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "text-primary btn-light border-0 py-0 toggler",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navbarText",
          "aria-controls": "navbarText",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
          id: "nav-toggle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle', $event)))
        }, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                id: "notify-li",
                role: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false",
                class: "nav-link dropdown-toggle text-primary s-name",
                to: "#"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              }),
              _hoisted_10
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createElementVNode("span", {
                class: "initial_container",
                style: _normalizeStyle(`background-color: ${_ctx.userBg}`)
              }, _toDisplayString(_ctx.initials || "UserName"), 5)
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createElementVNode("button", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.name), 1)
              ]),
              _createElementVNode("ul", _hoisted_15, [
                (
                    _ctx.getDetails.account_type === 'innovators' ||
                    _ctx.getDetails.account_type === 'partners'
                  )
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      class: "dropdown-item text-primary cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.gotoProfile && _ctx.gotoProfile(...args)), ["prevent"]))
                    }, [
                      _hoisted_16,
                      _createTextVNode(" Profile ")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, _hoisted_18)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}